import { ERROR } from "../action/action-types";

export default function error(state = null, action){
    switch(action.type){
        case ERROR:
            return state = action.payload
        default:
            return state
    }
}